import SuccessDialogProvider from 'components/ui/SuccessDialog/SuccessDialogContext'
import PermissionsProvider from 'contexts/PermissionsContext'
import { Outlet } from 'react-router-dom'

function App() {

  return (
    <PermissionsProvider>
      <SuccessDialogProvider>
        <Outlet />
      </SuccessDialogProvider>
    </PermissionsProvider>
  )
}

export default App
